module.exports = {"pathContext":{"name":"LabTrendStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"The result is on the job.","isDeprecated":false,"name":"COMPLETED"},{"deprecationReason":null,"description":"The engine could not generate this patient's trends.","isDeprecated":false,"name":"FAILED"},{"deprecationReason":null,"description":"Queued or running.","isDeprecated":false,"name":"PENDING"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-lab-trend-status.json
// module id = 1259
// module chunks = 166457285261563